var map = {
	"./LogoPMS.svg": "tz3W",
	"./LogoPMS_old.svg": "/3wm",
	"./brasao-cor-branco-vertical.svg": "wOM0",
	"./conecte-sus.svg": "c/cq",
	"./ico-assistencia.svg": "9+xg",
	"./ico-azul.svg": "iDa5",
	"./ico-compras.svg": "kzZg",
	"./ico-comunicacao.svg": "Glix",
	"./ico-cultura.svg": "pdY+",
	"./ico-default.svg": "6ig6",
	"./ico-educacao.svg": "TeJu",
	"./ico-esporte.svg": "8m+r",
	"./ico-financas.svg": "R+m3",
	"./ico-gestao.svg": "lFPT",
	"./ico-governo.svg": "k82x",
	"./ico-imovel.svg": "G2dL",
	"./ico-manutencao.svg": "adyD",
	"./ico-meioambiente.svg": "uC+7",
	"./ico-ouvidoria.svg": "GIS3",
	"./ico-porto.svg": "Ffni",
	"./ico-saude.svg": "yZwr",
	"./ico-seguranca.svg": "M9oD",
	"./ico-servico-servicospublicos.svg": "V7DC",
	"./ico-servidor.svg": "jDDP",
	"./ico-turismo.svg": "8bzg",
	"./ico-urbanismo.svg": "MEYP",
	"./ico-verde.svg": "i1A9",
	"./ico-vermelho.svg": "3R7G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6K9S";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img ^\.\/.*\.svg$
// module id = 6K9S
// module chunks = 15